import { appStateReducers } from './redux/reducers/context.reducers';
import { APP_INITIALIZER, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AgmCoreModule } from '@agm/core';

import { OverlayContainer, Overlay } from '@angular/cdk/overlay';
import { MAT_MENU_SCROLL_STRATEGY } from '@angular/material/menu';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';
import { menuScrollStrategy } from './theme/utils/scroll-strategy';

import { environment } from 'src/environments/environment';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'; 
export function HttpLoaderFactory(httpClient: HttpClient) { 
  return new TranslateHttpLoader(httpClient, environment.url +'/assets/i18n/', '.json');
}

import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { MenuComponent } from './theme/components/menu/menu.component';
import { SidenavMenuComponent } from './theme/components/sidenav-menu/sidenav-menu.component';
import { BreadcrumbComponent } from './theme/components/breadcrumb/breadcrumb.component';

import { AppSettings } from './app.settings';
import { AppService } from './app.service';
import { AppInterceptor } from './theme/utils/app-interceptor';
import { OptionsComponent } from './theme/components/options/options.component';
import { FooterComponent } from './theme/components/footer/footer.component';
import { ServiceLocator } from './services/locator.service';
import { GbcarApiModule } from 'src/api/gbcar/gbcar-api.module';
import { EnvServiceProvider } from './services/env.service.provider';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SocialIconsComponent } from './theme/components/social-icons/social-icons.component';
import { TokenGuardService } from './services/token-guard.service';

//-SPA only
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AuthenticationService } from './services/authentication.service';

export function initTokenGuardServiceFactory(tokenGuardService: TokenGuardService) {
  return () => tokenGuardService.initialize();
}

@NgModule({
   imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    HttpClientModule,
    // @ts-ignore
    GbcarApiModule.forRoot({ rootUrl: window.__env.litaliaApiUrl }),
    NgxSpinnerModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAhjnaT-M2vpoH-OoRPuAKOy5UIDTJ7r3Y'
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ReactiveFormsModule,
    SharedModule,
    StoreModule.forRoot(appStateReducers),
    AppRoutingModule,
    LazyLoadImageModule,
  ],
  declarations: [
    AppComponent,
    PagesComponent,
    NotFoundComponent,    
    MenuComponent,
    SidenavMenuComponent,
    SocialIconsComponent,
    BreadcrumbComponent,
    OptionsComponent,
    FooterComponent    
  ], 
  providers: [
    AppSettings,
    AppService,
    EnvServiceProvider,
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    { provide: MAT_MENU_SCROLL_STRATEGY, useFactory: menuScrollStrategy, deps: [Overlay] },
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    { provide: TokenGuardService},
    {
      provide: APP_INITIALIZER,
      useFactory: initTokenGuardServiceFactory,
      deps: [TokenGuardService, AuthenticationService],
      multi: true
    },
    //-SPA only - in case of SSR remove it!
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: LOCALE_ID, useValue: 'hu-HU'},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor(private injector: Injector) {
    ServiceLocator.injector = this.injector;    
  }
}